module.exports = "https://health.dajiuxing.com.cn/img/assets/healthReportList/headbackground.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FhealthReportList%2Fheadbackground.png
// module id = cXDx
// module chunks = 93